import { AfterViewInit, Component, OnDestroy, inject } from '@angular/core';
import {ZendeskService} from '../../services/zendesk.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let zE: any; // Declare zE to satisfy the compiler (outside library)

@Component({
  selector: 'app-zendesk-chat',
  imports: [],
  templateUrl: './zendesk-chat.component.html',
  styleUrl: './zendesk-chat.component.scss'
})
export class ZendeskChatComponent implements AfterViewInit, OnDestroy {
	private router = inject(Router);
	private zendeskService = inject(ZendeskService);


	metadataChanges$?: Subscription;

	ngAfterViewInit() {
		// load zendesk script tag
		this.zendeskService.load().then(() => {
			// Set up handling for when the widget is opened
			zE("messenger:on", "open", this.zendeskService.onWidgetOpen);

			// Set up handling for when the widget is closed
			zE("messenger:on", "close", this.zendeskService.onWidgetClose);
		});

		// subscribe to route for conversation metadata changes
		this.metadataChanges$ = this.zendeskService.subscribeToRouteChanges(this.router.events);
	}

	ngOnDestroy() {
		this.metadataChanges$?.unsubscribe();
	}

}
